import {
  Flex,
  Text,
  Image,
  TextAsProps,
  TextColorProps,
  Box,
  Tag,
} from 'components/elements'
import { SvgCircleWrap, SvgWrap } from 'components/svg'
import { AlignItemsProps } from 'config/types'
import { ReactNode } from 'react'
import { styled, CSS } from 'theme'
import { GroupIconCss, LinkItem, overflowText } from 'theme/globalStyleCss'

export const TextBox = styled(Box, {
  overflow: 'hidden',

  variants: {
    size: {
      xxs: {
        ml: '$space$8',
      },
      xs: {
        ml: '$space$8',
      },
      sm: {
        ml: '$space$8',
      },
      md: {
        ml: '$space$12',
      },
      lg: {
        ml: '$space$12',
      },
      xl: {
        ml: '$space$12',
      },
      login: {
        ml: '$space$12',
      },
      container: {},
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

// [TODO add all level here]
export type AvatarSizeProps =
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'login'
  | 'container'

interface AvatarProps {
  enableLink?: string
  children?: ReactNode
  size?: AvatarSizeProps
  color?: TextColorProps
  textSmall?: boolean
  title?: string
  subTitle?: ReactNode | string
  description?: string
  status?: string
  image?: {
    url?: string
    imageType?: AvatarSizeProps | 'full' | 'auto' | '100' | '120' | 'rectangle'
  }
  isCompany?: boolean
  css?: CSS
  textCss?: {
    title?: CSS
    subTitle?: CSS
    description?: CSS
  }
  extraItems?: ReactNode
  textBoxCss?: CSS
  isList?: boolean
  direction?: 'column' | 'row'
  alignItem?: AlignItemsProps
  setIcon?: {
    icon: ReactNode
    iconColor?: any
    iconStyle?: CSS
    iconType?: AvatarSizeProps | 'xlg'
    rings?: boolean
  }
  avatarDirection?: 'column' | 'row'
  titleSize?: TextAsProps
}

const Avatar = ({
  enableLink,
  children,
  size,
  textSmall,
  title,
  subTitle,
  description,
  css,
  textCss,
  isList,
  status,
  image,
  isCompany,
  setIcon,
  direction,
  alignItem,
  color,
  extraItems,
  textBoxCss,
  avatarDirection,
  titleSize,
}: AvatarProps) => {
  const { icon, iconStyle, iconType, iconColor, rings } = setIcon || {}
  const { url, imageType } = image || {}
  let headingSize: TextAsProps

  switch (size) {
    case 'xs':
      headingSize = 'h6'
      break
    case 'sm':
      headingSize = 'h5'
      break
    case 'md':
      headingSize = 'h4'
      break
    case 'lg':
      headingSize = 'h3'
      break
    case 'xl':
      headingSize = 'h1'
      break
    default:
      headingSize = 'h6'
  }

  const removeSpace: CSS = !icon
    ? {
        m: 0,
      }
    : {}

  const TextCss: CSS = isList
    ? {
        mr: 0,
      }
    : {}

  const stringLink = enableLink?.replace(/\s/g, '')

  return (
    <Flex
      align={alignItem || 'center'}
      direction={avatarDirection}
      css={{ overflow: 'hidden', ...css }}
      className="avatar"
    >
      {!!icon ? (
        rings ? (
          <SvgCircleWrap
            color={color}
            css={{
              ...GroupIconCss,
              ml: '-$space$4',
              my: '-$space$4',
              ...iconStyle,
            }}
          >
            {icon}
          </SvgCircleWrap>
        ) : (
          <SvgWrap
            size={iconType ? iconType : size ? size : 'xs'}
            color={iconColor || color}
            css={iconStyle}
          >
            {icon}
          </SvgWrap>
        )
      ) : (
        url && (
          <Image
            isIcon={true}
            size={imageType || size}
            border
            url={url}
            css={{ ...(isCompany ? CompanyImageCss : {}) }}
          />
        )
      )}
      <TextBox size={size} css={{ ...(url ? {} : removeSpace), ...textBoxCss }}>
        <Flex>
          <Text
            as={titleSize || headingSize}
            color={color}
            css={{
              ...TextCss,
              ...removeSpace,
              ...textCss?.title,
              ...overflowText,
            }}
          >
            {title}
          </Text>
          {!!status ? (
            <Tag
              size="smRounded"
              color={'primary'}
              children={status}
              css={{
                ml: '$space$6',
                maxWidth: 120,
              }}
            />
          ) : null}
        </Flex>
        {!!enableLink ? (
          <LinkItem
            css={{ ...textCss?.subTitle, ...overflowText }}
            to={`${stringLink}`}
          >
            {subTitle}
          </LinkItem>
        ) : (
          <Text
            css={{ ...textCss?.subTitle, ...overflowText }}
            as={textSmall ? 'p' : 'pExtend'}
            color={color}
          >
            {subTitle}
          </Text>
        )}
        {description && (
          <Text
            as="p"
            css={{
              ...textCss?.description,
              // ...overflowText,
              ...removeSpace,
            }}
          >
            {description}
          </Text>
        )}
        {extraItems}
      </TextBox>
      {children}
    </Flex>
  )
}

export default Avatar

const CompanyImageCss = {
  borderRadius: 5,
  boxShadow: 'none',
  border: '1px solid $border',
}
